/* @flow */

import React from 'react';
import { useTheme } from '@mui/styles';
import { VolumeOffIcon } from 'assets/images';
import PropTypes from 'prop-types';
import BaseIndicator from './BaseIndicator';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const SpeakerOffIndicator = ({ tooltipPosition }) => {
  const theme = useTheme();

  return (
    <BaseIndicator
      icon={VolumeOffIcon}
      iconColor={theme.palette.iconError}
      iconId="speaker-disabled"
      iconSize={12}
      id="speakerMuted"
      tooltipKey="videothumbnail.mute"
      tooltipPosition={tooltipPosition}
    />
  );
};

export default React.memo(withBoundary(SpeakerOffIndicator));
SpeakerOffIndicator.propTypes = {
  tooltipPosition: PropTypes.string
};
